<ng-template #content let-modal>
	<div class="modal-header">
		<ng-content select="[title-icon]"></ng-content>
		<div class="modal-title"><ng-content select="[title-desc]"></ng-content></div>
	</div>
	<div class="modal-body">
		<ng-content></ng-content>
    </div>
</ng-template>